import React from "react";

const MicrosoftIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      {...props}
    >
      <path d="M0.5 0H20.5V20H0.5V0Z" fill="#F3F3F3" />
      <path d="M1.36963 0.869629H10.0653V9.56528H1.36963V0.869629Z" fill="#F35325" />
      <path d="M10.9346 0.869629H19.6302V9.56528H10.9346V0.869629Z" fill="#81BC06" />
      <path d="M1.36963 10.4346H10.0653V19.1302H1.36963V10.4346Z" fill="#05A6F0" />
      <path d="M10.9346 10.4346H19.6302V19.1302H10.9346V10.4346Z" fill="#FFBA08" />
    </svg>
  );
};

export default MicrosoftIcon;
